import React from "react";
import { BadgeDollarSign, Eye, ShoppingCart } from "lucide-react";

interface TemplateCTAProps {
  price: number;
  originalPrice?: number; // Opcional, si hay un precio tachado
  onPreviewClick: () => void;
  onAddToCart: () => void;
}

const TemplateCTA: React.FC<TemplateCTAProps> = ({ price, originalPrice, onPreviewClick, onAddToCart }) => {
  return (
    <div className="bg-gradient-to-r from-navy-900 to-blue-900 rounded-2xl p-8 shadow-2xl">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
        
        {/* Información de precio */}
        <div className="space-y-2 text-white">
          <div className="flex items-center gap-3">
            <BadgeDollarSign className="w-8 h-8 text-white" />
            <div>
              <h3 className="text-2xl font-bold">Premium Template</h3>
              {originalPrice && <p className="text-lg text-blue-200 line-through">${originalPrice}</p>}
            </div>
          </div>
          <p className="text-4xl font-bold">${price}</p>
          <p className="text-sm text-blue-200">One-time payment, lifetime updates</p>
        </div>

        {/* Botones */}
        <div className="flex flex-col gap-4 w-full lg:w-auto mt-4 lg:mt-0">
          <button 
            type="button" 
            onClick={onPreviewClick}
            className="px-8 py-4 border border-white/30 text-white rounded-xl font-bold hover:bg-white/10 transition-colors flex items-center gap-2 justify-center"
          >
            <Eye className="w-5 h-5" />
            Live Preview
          </button>
          
          <button 
            type="button" 
            onClick={onAddToCart}
            className="px-8 py-4 bg-white text-navy-900 rounded-xl font-bold hover:scale-105 transition-transform shadow-lg flex items-center gap-2 justify-center"
          >
            <ShoppingCart className="w-5 h-5" />
            Add to Cart
          </button>
        </div>

      </div>
    </div>
  );
};

export default TemplateCTA;
